import { useNavigate } from 'react-router-dom';

import { ArrowLeft } from 'lucide-react';

import Header from '@/components/common/Header';

import { Button } from '../../components/ui/button';

const NotFoundContent = () => {
  const navigate = useNavigate();

  return (
    <section className='min-h-screen w-full flex flex-col'>
      <Header />

      <div className='flex flex-col items-center gap-4'>
        <div className='embossed-text text-[185px]'>404</div>

        <div className='flex flex-col items-center gap-8'>
          <div className='flex flex-col items-center gap-2'>
            <p className='font-semibold'>Oops, something went wrong...</p>
            <p>The page you're looking for doesn't exist or has been moved.</p>
          </div>

          <Button variant={'yellow'} onClick={() => navigate(-1)}>
            <ArrowLeft /> Go back
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NotFoundContent;
